module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "tbl02"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("List of Tables")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c01_r1#TAB-1.1-section-1-6-1"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 1.1")])]), _vm._v(" Middle East Proven Petroleum Reserves")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c01_r1#TAB-1.2-section-1-6-1"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 1.2")])]), _vm._v(" Middle East Oil Production")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c04_r1#TAB-4.1-section-1-6-4-1-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 4.1")])]), _vm._v(" Big Four Saudi Fields Oil Production and Reserves, 1976")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c04_r1#TAB-4.2-section-1-6-4-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 4.2")])]), _vm._v(" Saudi Arabian Oil Production by Field, 1994")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c05_r1#TAB-5.1-section-1-7-1-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 5.1")])]), _vm._v(" Reported Peak Output and Year for the Main Saudi Fields, Annual Average Barrels per Day")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c10_r1#TAB-10.1-section-1-8-4-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 10.1")])]), _vm._v(" Announced Saudi Arabian Oil and Gas Discoveries, 2002-2004")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c11_r1#TAB-11.1-section-1-8-5-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table 11.1")])]), _vm._v(" Original Core Venture Projects for the Saudi Gas Initiative")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.1-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Table B.1")])]), _vm._v(" Discovered Saudi Arabian Oilfields as of 2000")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.2-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.2")])]), _vm._v(" Simplified Overview of Saudi Arabia’s Geological Formations")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.3-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.3")])]), _vm._v(" Contributions of Sustaining Oilfields to Saudi Production Build, 1951-1981 (thousand barrels per day)")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.4-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.4")])]), _vm._v(" Parameters Affecting Arab D Productivity in Areas of Ghawar")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.5-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.5")])]), _vm._v(" Parameters Affecting Productivity in the Oil Reservoirs of the Abqaiq, Safaniya, and Zuluf Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.6-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.6")])]), _vm._v(" Key Steps in Establishing Proven Reserves")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.7-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.7")])]), _vm._v(" Reported Reserves Fluctuations and Production for Key Saudi Fields, 1973-1977")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.8-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.8")])]), _vm._v(" Production from World’s Largest Giant Fields, 1971 and 2000 (thousand barrels per day)")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#TAB-b.9-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Table B.9")])]), _vm._v(" Age and Supply Contribution of Giant Oilfields in 2000")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d24d88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simm_9781118040522_oeb_tbl02_r1.vue
// module id = 63
// module chunks = 0